import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( {
	imagesTabWrapper: {
		gap                 : "2rem",
		display             : "grid",
		padding             : "2rem",
		gridTemplateColumns : "repeat(auto-fill, minmax(250px, 1fr))",

		[rooterMediaQuery.tablet]: {
			gridTemplateColumns : "repeat(auto-fill, minmax(140px, 1fr))",
			gap                 : "1.6rem",
			padding             : "0"
		},

		[rooterMediaQuery.mobile]: {
			gridTemplateColumns : "repeat(auto-fill, minmax(100px, 1fr))",
			gap                 : "0.25rem",
			padding             : "0",
			marginBottom        : "70px"
		}

	}
} );
